export enum Application {
  APP = 'APP',
  AURA = 'AURA',
  HELIO = 'HELIO',
  QUARK = 'QUARK',
  ONBOARDING = 'ONBOARDING',
  TOOLS = 'TOOLS',
}
